// extracted by mini-css-extract-plugin
export default {"btnpwd":"_1ccedec82a"};